import { CircularProgress } from "@mui/material";
import { Button } from "@gisce/oficina-virtual-components";
import { useDispatch, useSelector } from "react-redux";
import { GetApp } from "@mui/icons-material";
import {
  exportDocumentRepositoryAttachment,
  exportDocumentRepositoryAttachments,
} from "../actions/attachments";
import { useTranslation } from "react-i18next";

export const DownloadButton = ({
  attachment,
  attachments = [],
  disabled = false,
  buttonText,
  title,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const token = useSelector((state) => state.profile.token);
  const downloadStatus = useSelector((state) =>
    attachment
      ? state.documentRepository.download_status[attachment.rowId || attachment.id]
      : state.documentRepository.download_all_status
  );

  const handleDownload = () => {
    if (attachment) {
      dispatch(exportDocumentRepositoryAttachment(token, attachment));
      return;
    }

    if (!attachments.length) {
      return;
    }

    dispatch(
      exportDocumentRepositoryAttachments(token, attachments)
    );
  };

  return (
    <Button
      title={title || buttonText}
      color="primary"
      variant="contained"
      onClick={handleDownload}
      disabled={disabled || downloadStatus}
    >
      {downloadStatus ? (
        <CircularProgress size={20} sx={{ marginRight: '5px' }} />
      ) : (
        <GetApp />
      )}
      {buttonText || (
        attachment
          ? t('common:text.document_repository_download_attachment')
          : t('common:text.document_repository_download_selected')
      )}
    </Button>
  );
};
